package opengraphlinks

import analytics.AnalyticsCategory
import analytics.analyticsEvent
import apiclient.FormationClient
import apiclient.geoobjects.Content
import apiclient.geoobjects.OpenGraphMetadata
import apiclient.opengraph.linkPreview
import apiclient.util.isNotNullOrEmpty
import data.objects.views.directediting.fixOldLinks
import data.objects.views.directediting.youtubePreview
import dev.fritz2.core.RenderContext
import dev.fritz2.core.RootStore
import dev.fritz2.core.crossOrigin
import dev.fritz2.core.rel
import dev.fritz2.core.src
import koin.withKoin
import kotlinx.browser.window
import kotlinx.coroutines.Job
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch
import theme.FormationUIIcons
import twcomponents.twFlatCopyClipboardButton
import twcomponents.twIconMedium
import twcomponents.twRowOfJustifyBetween
import twcomponents.twTextLinkButton


private class OgmStore(link: String, title: String?) : RootStore<OpenGraphMetadata>(OpenGraphMetadata(title = title, url=link), Job()) {
    init {
        MainScope().launch {
            withKoin {
                val client = get<FormationClient>()
                val result = client.linkPreview(link)
                if(result.isSuccess) {
                    update(result.getOrThrow())
                } else {
                    update(OpenGraphMetadata(title = title, url=link))
                }
            }
        }
    }
}

fun RenderContext.showLinkWithPreview(content: Content.WebLink) {
    val store = OgmStore(content.href,content.title)
    store.data.render {openGraphMetadata->
        val bestTitle = content.title.takeIf { it.isNotNullOrEmpty() } ?: openGraphMetadata.title ?: content.href
        div("flex flex-col w-full items-stretch justify-start px-2 pt-2 gap-2") {
            div("flex flex-row w-full items-center justify-start gap-4") {
                openGraphMetadata.siteIcon?.let { siteIcon ->
                    img("h-8 object-contain") {
                        crossOrigin("anonymous")

                        src(fixOldLinks(siteIcon))
                    }
                }
                div("text-sm font-bold text-ellipsis overflow-hidden") {
                    +bestTitle
                }
            }
            if (content.href.contains("youtube")) {
                youtubePreview(content.href, true, true)
            } else {
                // image
                openGraphMetadata.image?.let { imgSrc ->
                    a("flex items-center justify-center w-full") {
                        content.rel?.let {  rel(it) }
                        clicks handledBy {
                            analyticsEvent(AnalyticsCategory.WebLink, content.href, label = bestTitle)
                            window.open(content.href, "_blank") // Open the link in a new tab
                        }

                        img("w-full object-cover max-h-64") {
                            crossOrigin("anonymous")
                            src(fixOldLinks(imgSrc))
                        }
                    }
                }
            }
            content.openGraphMetadata?.description?.let { description ->
                p("text-xs") {
                    +description
                }
            }
            twRowOfJustifyBetween {
                className("pl-2 -mx-2")
                twIconMedium(FormationUIIcons.Link)
                twTextLinkButton {
                    clicks handledBy {
                        analyticsEvent(AnalyticsCategory.WebLink, content.href, label = bestTitle)
                        window.open(content.href, "_blank") // Open the link in a new tab
                    }

                    +content.href
                }
                twFlatCopyClipboardButton(content.href)
            }
        }
    }
}
